var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngryReactionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108.28 108.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4caf50;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2.24px;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 54.14,
    cy: 54.14,
    r: 36.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.51,31.9c4.81,6.13,7.68,13.85,7.68,22.24,0,19.91-16.14,36.04-36.04,36.04s-36.04-16.14-36.04-36.04S34.23,18.1,54.14,18.1c12.26,0,23.1,6.12,29.61,15.48"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.35,72.72h-38.42c3.31-7.31,10.68-12.42,19.21-12.42s15.89,5.11,19.21,12.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.35,72.72h-38.42c3.31-7.31,10.68-12.42,19.21-12.42s15.89,5.11,19.21,12.42Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Angry_evil_hatred_emoji",
    "data-name": "Angry, evil, hatred, emoji"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 74.29,
    y1: 40.7,
    x2: 60.86,
    y2: 50.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.83,45.22c1.11.13,1.96,1.05,1.96,2.2,0,1.24-.98,2.22-2.22,2.22s-2.22-.98-2.22-2.22c0-.17.02-.34.06-.51"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 33.95,
    y1: 40.7,
    x2: 47.39,
    y2: 50.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.41,45.22c-1.11.13-1.96,1.05-1.96,2.2,0,1.24.98,2.22,2.22,2.22s2.22-.98,2.22-2.22c0-.17-.02-.34-.06-.51"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngryReactionIcon);
export default __webpack_public_path__ + "static/media/angry-reaction-icon.540bb077108664096a6c01a4131af211.svg";
export { ForwardRef as ReactComponent };